import { Card, CardContent, Checkbox, Drawer, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import { useRef, useCallback, useState, useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import TuneIcon from '@mui/icons-material/Tune';
import Scrollbars from 'rc-scrollbars';
import PropTypes from 'prop-types';
import ClassicSearch from './classicSearch';
import { DealDetails } from 'utils/formatters';
import { get } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import { ImgMagazine } from './SelectMarket';
import { getDataSource } from 'api/ds';
import { ShowModal } from './Modal';
import { ElementInfo } from './ElementInfo';
import Loading from './Load';

export default function GlobalSearch({ cancel }) {
    
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    /** @type {[any, Function]} */
    const [results, setResuls] = useState([]);


    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const [open, setOpen] = useState(undefined)
    const eids = getDataSource('EIDeal')

    const togleEI = (deal) => {
        if (!deal && unsavedChanges) {
            ShowModal(
                'Несохраненные изменения',
                <div>У вас есть несохраненные данные. Вы уверены, что хотите закрыть шторку?</div>,
                async () => {
                    setOpen(deal)
                }
            );
            return;
        }
        setOpen(deal)
        
    }

    const { company_id } = useSelector(
        loginSelector
    );

    useEffect(() => {
        
        const findData = async () => {
            setLoading(true)
            setChecked(false)
            let tmp = await get("Deal/searchDeal", {cid: company_id, text: filter})
            setResuls(tmp)
            setLoading(false)
        }

        if (checked) {
            findData()
        }
    }, [checked]);
    

    return (
        <div style={{width: '98%', height: "98%", margin: '1%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div style={{marginLeft: '7%', height: "10%", width: '90%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <ClassicSearch 
                    setChecked={setChecked} 
                    setFilter={setFilter} 
                    checked={checked}
                    // @ts-ignore
                    customWidth={"100%"}
                />
            </div>
            {loading? <Loading/>:
                <Scrollbars
                    autoHide
                    style={{ width: '100%', height: '90%', display: "flex", flexDirection: 'column', alignItems: 'center'}}
                >
                    {results.map((deal) => 
                        <Card
                            sx={{
                                margin: '5px 1% 5px 1%',
                                width: '98%',
                                backgroundColor: 'white',
                                borderRadius: "10px",
                                cursor: 'pointer',
                                transition: 'background-color 0.2s ease',
                                '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.12)', // затемнение при наведении
                                },
                            }}
                            onClick={() => togleEI(deal.id)}
                            >
                            <CardContent
                                sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                p: '8px 16px',       // компактные отступы
                                '&:last-child': { pb: '8px' },
                                }}
                            >
                                <div style={{width: '10%'}}>
                                    <Typography sx={{ fontWeight: 'normal', fontSize: '14pt' }}>
                                        {deal.cdn}
                                    </Typography>
                                </div>
                                <div style={{width: '50%', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                    <Typography sx={{ fontWeight: 'normal', fontSize: '14pt' }}>
                                        {deal.client_id} - 
                                    </Typography>
                                    <Typography sx={{ fontWeight: 'normal', fontSize: '14pt' }}>
                                        {deal.cli_name}
                                    </Typography>
                                </div>
                                <div style={{width: '20%', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                    <ImgMagazine magazine={deal.market} size={20} user_id={deal.client_id}/>    
                                    <DealDetails value={deal.dealDetails}/>
                                </div>
                            </CardContent>
                            </Card>
                    )}
                </Scrollbars>
            }
            <Drawer
                anchor='right'
                open={open}
                onClose={() =>{togleEI(undefined)}}
                // hideBackdrop 
                sx={{
                    '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    },
                    zIndex: 1301
                }}
            >
                <ElementInfo 
                ds={eids} 
                data={open} 
                // @ts-ignore
                setChanged={setUnsavedChanges} 
                />
            </Drawer>
        </div>
    )
}
